import { useEffect, useState } from "preact/hooks";
import { SearchProducts } from "@nosto/nosto-js/client";
import { useOnSubmit } from "../OnSubmitContext";
import { cl } from "@nosto/search-js/utils";
import DynamicProduct from "@/components/Autocomplete/DynamicCardProduct/DynamicCardProduct";

export type ProductsProps = {
  products: SearchProducts;
  query: string;
};

export default function Products({ products, query }: ProductsProps) {
  const [isGridReady, setIsGridReady] = useState(false);
  const onSubmit = useOnSubmit();

  useEffect(() => {
    if (products) {
      setIsGridReady(false);
      const timer = setTimeout(() => {
        setIsGridReady(true);
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [products]);

  if (!products?.hits?.length) {
    return null;
  }

  return (
    <>
      <h4>Related Products</h4>
      <div
        className={cl(
          "search-dropdown-panel__grid",
          isGridReady && "search-dropdown-panel__grid--is-loaded",
        )}
      >
        {products.hits.map((hit) => (
          <DynamicProduct key={hit.productId} hit={hit} />
        ))}
      </div>
      {isGridReady && (
        <button
          onClick={() => onSubmit(query)}
          className="mt-8 br-button br-button--secondary br-button--handdrawn flex mx-auto"
        >
          See all products
        </button>
      )}
    </>
  );
}
